import { useTranslation } from "react-i18next"
import CommonUtil from "../../../utils/CommonUtil"
import { useEffect } from "react"

const BatteryTime = props => {
    const { t } = useTranslation()

    const postTitle = () => {
        if (CommonUtil.isInApp(navigator.userAgent)) {
            window.ReactNativeWebView.postMessage(t('battery_item1'))
        }
    }

    useEffect(() => {
        postTitle()
    }, [])

    return <div className="App">
        <div className="bind-device-faq-marginH20">
            <img src={`${CommonUtil.getSourceDomain()}battery_life.png`} alt="" style={{ width: '100%', marginTop: 15 }} />
        </div>
    </div>
}

export default BatteryTime